export default function mask() {
    if (document.querySelector("#phone")) {
        $("#phone").mask("(00) 00000-0000");
    }

    if (document.querySelector("#phone-broker")) {
        $("#phone-broker").mask("(00) 00000-0000");
    }
}